import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { databases, storage } from "./appwrite";
import { ShieldCheck, ShieldX } from "lucide-react";

const DB_ID = process.env.REACT_APP_APPWRITE_DB_ID || "regdb";
const COL_ID =
  process.env.REACT_APP_APPWRITE_COLLECTION_ID || "692a9f82002dabe4ac9c";
const BUCKET_ID = "mmttcregid";

export default function VerifyProfile() {
  const { userId } = useParams();
  const [user, setUser] = useState(null);
  const [photoUrl, setPhotoUrl] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    (async () => {
      try {
        const doc = await databases.getDocument(DB_ID, COL_ID, userId);
        setUser(doc);

        if (doc.photoFileId) {
          const url = storage.getFileView(BUCKET_ID, doc.photoFileId, 200, 200);

          const img = new Image();
          img.src = url;
          img.onload = () => setPhotoUrl(url);
          img.onerror = () => setPhotoUrl("");
        } else {
          setPhotoUrl("");
        }

        setStatus("verified");
      } catch {
        setStatus("invalid");
      }
    })();
  }, [userId]);

  if (status === "loading") {
    return (
      <div className="h-screen flex items-center justify-center text-sm text-gray-600">
        Verifying authenticity…
      </div>
    );
  }

  if (status === "invalid") {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-red-50 text-center p-6">
        <ShieldX size={56} className="text-red-600 mb-4" />
        <h1 className="text-xl font-bold text-red-700">
          Invalid or Unverified ID
        </h1>
        <p className="text-sm text-gray-600 mt-2 max-w-sm">
          This QR code does not match any record in the official MMTTC database.
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-green-50 p-6">
      <div className="bg-white rounded-2xl shadow-xl p-6 max-w-md w-full text-center">
        <ShieldCheck size={56} className="text-green-600 mx-auto mb-3" />

        <h1 className="text-xl font-bold text-gray-900">Profile Verified</h1>

        {/* PHOTO */}
        <div className="w-24 h-24 mx-auto my-4 rounded-full overflow-hidden border flex items-center justify-center bg-gray-100">
          {photoUrl === null ? (
            <span className="animate-pulse text-[10px] text-gray-400">
              loading…
            </span>
          ) : photoUrl ? (
            <img
              src={photoUrl}
              alt="Profile"
              className="w-full h-full object-cover"
            />
          ) : (
            <img
              src="/user.png"
              alt=""
              className="w-full h-full object-cover"
            />
          )}
        </div>

        <div className="text-sm text-gray-700 space-y-1 mx-auto">
          <div className="flex justify-between">
            <span className="font-mono text-indigo-700">Name</span>
            <span className="font-mono">{user.name}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-mono text-indigo-700">Designation</span>
            <span className="font-mono">{user.designation}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-mono text-indigo-700">Department</span>
            <span className="font-mono">{user.department}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-mono text-indigo-700">Affiliation</span>
            <span className="font-mono">{user.affiliation}</span>
          </div>
        </div>

        <p className="mt-4 text-xs text-green-500 text-center font-mono italic text-sm bg-green-100 p-2 rounded-lg">
          Verified against the official MMTTC participant registry
        </p>
      </div>
    </div>
  );
}
